import DataFreshness from "./DataFreshness";

export default DataFreshness;
